export enum SPINNER_SIZE {
  xSmall = "xSmall",
  small = "small",
  medium = "medium",
  large = "large",
  xLarge = "xLarge",
}

export enum SPINNER_KIND {
  dark = "dark",
  light = "light",
}
